import Testimonials from "../../components/Testimonials/Testimonials";
import AboutMe from "../../components/AboutMe/AboutMe";
import NavBar from "../../components/NavBar/Navbar";
import Welcome from "../../components/Welcome/Welcome";
import WhatIDo from "../../components/WhatIDo/WhatIDo";
import Portfolio from "../../components/Portfolio/Portfolio";
import Footer from "../../components/Footer/Footer";
import Contact from "../../components/Contact/Contact";
function HomeScreen() {
  return (
    <>
      <NavBar />
      <Welcome />
      <WhatIDo />
      <AboutMe />
      <Testimonials />
      <Portfolio />
      <Contact />
      <Footer />
    </>
  );
}

export default HomeScreen;
